<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="breakpoints.lgAndUp ? '30%' : '75%'"
    top="20vh"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mb-6 pb-4 text-black-2">
      <div class="flex justify-center mt-10"><withdrawal-error /></div>
      <div
        class="font-bold text-xl text-black-2 flex justify-center my-4 text-center"
      >
        Your account is yet <br />
        to be activated
      </div>
      <div @click="contactSupport"><o-button> Contact Support</o-button></div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import app from '@/mixins/app.js'

export default {
  name: 'BusinessActiveErrorDialog',
  mixins: [app],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    contactSupport () {
      window.open(
        this.tenantIsTorus
          ? 'mailto:hello@torusmara.com'
          : 'https://ovalfi.atlassian.net/servicedesk/customer/portal/'
      )
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  components: {
    WithdrawalError: () => import('@/assets/images/WithdrawalError.vue')
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
